import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import { formatPortalCreditsBalance } from '../utils/portal-users.mappers';
import type { PortalUser } from '../types/users.types';

interface CreditsCellProps {
  user: Pick<PortalUser, 'monthly_used' | 'credit_balance' | 'unlimited'>;
}

export function CreditsCell({ user }: CreditsCellProps) {
  const label = formatPortalCreditsBalance(user);
  const isEmpty = label === '—';

  return (
    <span
      className={cn(
        portalDs.tableCellMono,
        'text-[13px]',
        isEmpty ? 'text-[#9CA3AF]' : 'text-[#0D0F1A]'
      )}
    >
      {label}
    </span>
  );
}
